import { FETCH_DECKS } from '../constants/deck';

export function fetchDecks() {
  return {
    type: FETCH_DECKS,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: '/decks/'
    }
  };
}
